export default "/images/bandphoto-3.jpg?3a11e5d5f466646498bc804515c048b6";